/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-plusplus */
/* eslint-disable no-prototype-builtins */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {
  BetResultStatusEnum,
  RouletteBetTargetTypeEnum,
  RouletteColorEnum,
  RouletteParityEnum,
  RouletteRoundStatusEnum,
  RouletteKingStateEnum,
} from './enum'

export interface ResultInfo {
  round_no?: string
  my_bet?: number
  my_win?: number
  others_win?: number
  hit_target?: number
  coin_num?: number
  top5_wins?: Array<number>
  win_bet_targets?: Array<number>
  bigger_winners?: Array<{
    id?: number
    win_coins?: number
    name?: string
    avatar?: string
    zy_id?: string
  }>
}

interface InitialStateType {
  base: {
    preActFinished: boolean
    playing: boolean
    loading: boolean
    showGuide: boolean
    guideStep: number
    isWebMsgGet: boolean
    betChip?: number
    resultAmis: boolean
  }
  home?: {
    target_order_list?: Array<{
      point: number
      color: RouletteColorEnum
    }>
    bet_chips?: Array<number>
    coin_num?: number
    today_win_sum?: number
    playing_users?: number
    own?: {
      id: number
      name: string
      zy_id: string
      avatar: string
    }
    history_results?: {
      round_no: number
      day_round: number
      hit_target: {
        point: number
        color: RouletteColorEnum
        parity: RouletteParityEnum
      }
    }
    top5_list?: Array<{
      id: number
      name: string
      zy_id: string
      avatar: string
    }>
  }
  roundInfo?: {
    betCountInfo?: any
    repeat_flag?: boolean
    otherUserChipsInfo?: any
    round_no?: string
    day_round?: number
    status_expire?: number
    hit_target?: number
    round_status?: RouletteRoundStatusEnum
    bet_targets?: Array<{
      tid: number
      fix_point: number
      odd: number
      my_bet?: number
      sum_bet?: number
      point_range: Array<number>
      type: RouletteBetTargetTypeEnum
      parity: RouletteParityEnum
      color: RouletteColorEnum
      bet_chips: Array<{
        value: number
        num: number
      }>
    }>
    winUsers?: Array<{
      seatId?: number
      amount?: number
    }>
  }
  result?: ResultInfo
  kingInfo: {
    resultShow?: boolean // 是否开奖
    open_times?: Array<string> // 活动开始时间和结束时间
    status?: RouletteKingStateEnum // 轮次状态:0:功能未开启;1:蓄力阶段;2:抢夺阶段
    jackpot_open_need?: number // 开启轮次抢夺需要的金币数额
    king_jackpot?: number // 当前奖池金额
    count_down?: number // 轮次倒计时
    champion_score?: number // 冠军积分
    my_score?: number // 我的积分
    champion_info?: {
      // 冠军
      id: number
      name: string
      zy_id: string
      avatar: string
    }
  }
}

export const get_roulette_homepage = createAsyncThunk(
  'get_roulette_homepage',
  async (arg, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/game/roulette_homepage',
      {
        ...deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const roulette_king_homepage = createAsyncThunk(
  'roulette_king_homepage',
  async (arg, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/game/roulette_king_homepage',
      {
        ...deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const roulette_bet = createAsyncThunk(
  'roulette_bet',
  async (
    arg: {
      bet_tid?: number
      h_web_room_id?: number
      bet_amount?: number
      bet_repeat?: boolean
    },
    store: any
  ) => {
    const {deviceinfo, otherInfo} = store.getState().env
    const resp = await http.post(
      '/live/game/roulette_bet',
      {
        ...arg,
        source: otherInfo.from,
        ...deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )

    return resp.data.data
  }
)
export const get_roulette_result = createAsyncThunk(
  'get_roulette_result',
  async (
    arg: {
      round_no?: string
    },
    store: any
  ) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/game/roulette_result',
      {
        ...arg,
        ...deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )

    return resp.data.data
  }
)

const initialState: InitialStateType = {
  roundInfo: {
    winUsers: [],
    betCountInfo: {},
  },
  base: {
    preActFinished: false,
    playing: true,
    loading: true,
    isWebMsgGet: false,
    showGuide: false,
    resultAmis: false,
    guideStep: 0,
  },
  home: {},
  result: {},
  kingInfo: {},
}

export const rouletteSlice = createSlice({
  name: 'roulette',
  initialState,
  reducers: {
    updatePlaying: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          playing: action.payload,
        },
      })
    },
    updateKingInfo: (state, action: PayloadAction<any>) => {
      const {kingInfo} = state
      Object.assign(state, {
        kingInfo: {
          ...kingInfo,
          ...action.payload,
        },
      })
    },
    updateResultAmis: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          resultAmis: action.payload,
        },
      })
    },
    updateLoading: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          loading: action.payload,
        },
      })
    },
    preActFinished: (state) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          preActFinished: true,
        },
      })
    },
    updateWebMsgGet: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          isWebMsgGet: action.payload,
        },
      })
    },
    updateShowGuide: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          showGuide: action.payload,
        },
      })
    },
    updateGuideStep: (state, action: PayloadAction<number>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          guideStep: action.payload,
        },
      })
    },
    changeBetChip: (state, action: PayloadAction<number>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          betChip: action.payload,
        },
      })
    },
    updateRoundInfo: (state, action: PayloadAction<any>) => {
      const {roundInfo} = state
      Object.assign(state, {
        roundInfo: {
          ...roundInfo,
          ...action.payload,
        },
      })
    },
    clearBetTargets: (state, action?: PayloadAction<any>) => {
      const {roundInfo} = state
      const temp = roundInfo.bet_targets.map((item) => ({
        ...item,
        my_bet: 0,
        sum_bet: 0,
      }))
      Object.assign(state, {
        roundInfo: {
          ...roundInfo,
          bet_targets: temp,
        },
      })
    },
    updateHome: (state, action: PayloadAction<any>) => {
      const {home} = state
      Object.assign(state, {
        home: {
          ...home,
          ...action.payload,
        },
      })
    },
    updateResult: (state, action: PayloadAction<any>) => {
      const {result} = state
      Object.assign(state, {
        result: {
          ...result,
          ...action.payload,
        },
      })
    },
    clearResult: (state, action?: PayloadAction<any>) => {
      Object.assign(state, {
        result: {},
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(get_roulette_homepage.fulfilled, (state, action) => {
      const {roundInfo, home} = state
      const {
        target_order_list,
        bet_chips,
        coin_num,
        today_win_sum,
        own,
        history_results,
        top5_list,
        playing_users,
        ...rest
      } = action.payload
      Object.assign(state, {
        roundInfo: {
          ...roundInfo,
          ...rest,
        },
        home: {
          ...home,
          target_order_list,
          bet_chips,
          coin_num,
          today_win_sum,
          own,
          history_results,
          top5_list,
          playing_users,
        },
      })
    })
    builder.addCase(roulette_bet.fulfilled, (state, action) => {
      const {roundInfo, home} = state
      const {status, coin_num, bet_targets} = action.payload
      const data =
        status === BetResultStatusEnum.success
          ? {
              roundInfo: {...roundInfo, bet_targets},
              home: {...home, coin_num},
            }
          : {}
      Object.assign(state, data)
    })
    builder.addCase(get_roulette_result.fulfilled, (state, action) => {
      Object.assign(state, {
        result: action.payload,
      })
    })
    builder.addCase(roulette_king_homepage.fulfilled, (state, action) => {
      const {kingInfo} = state
      Object.assign(state, {
        kingInfo: {
          ...kingInfo,
          ...action.payload,
        },
      })
    })
  },
})
export default rouletteSlice.reducer
export const rouletteActions = rouletteSlice.actions
